import * as Colors from 'material-ui/styles/colors';
import * as React from 'react';

import { Partner, Region, Role, StudioAppConfig } from 'glance-datatypes';
import { defaultTimezone, usTimezone } from './Clock';

import AppBar from 'material-ui/AppBar';
import { Configuration } from '../Configuration';
import CustomAppBar from './CustomAppBar';
import Divider from 'material-ui/Divider';
import Drawer from 'material-ui/Drawer';
import FontIcon from 'material-ui/FontIcon';
import { Link } from 'react-router';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import { connect } from 'react-redux';
import { fetchStudioAppConfig as fetchStudioAppConfigAction } from '../actions/draftsAction';

const styles = {
  footer: {
    marginTop: '5%',
    textAlign: 'center',
    width: '90%',
    margin: '0 auto',
    marginBottom: '2%',
  },
};

interface Props {
  location?: any;
  params?: any;
  history?: any;
  dispatchFetchStudioAppConfig?: Function;
  studioAppConfig: StudioAppConfig;
}

interface State {
  configuration?: Configuration;
  drawerOpen?: boolean;
}

const region = Region.US;

class App extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      drawerOpen: false,
    };

    this.updatePathPrefix = this.updatePathPrefix.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
  }

  path: string;
  pathPrefix: string;
  childrenWithProps: any[];
  updatePathPrefix(path: string) {
    let pathPrefix: string = '/partner';

    const pathEnd = path.indexOf('/', 1);
    //console.log(path, path.substr(1, pathEnd == -1 ? path.length -1  : pathEnd -1))

    if (
      path.substr(1, pathEnd == -1 ? path.length - 1 : pathEnd - 1) ===
      'moderator'
    )
      pathPrefix = '/moderator';

    this.pathPrefix = pathPrefix;
  }

  componentDidMount() {
    let path: string = this.props.location.pathname;
    this.path = path;
    this.updatePathPrefix(path);

    let that = this;

    let timezone = defaultTimezone;
    if (region == Region.US) {
      timezone = usTimezone;
    }
    const configuration: Configuration = new Configuration(timezone);
    Configuration.setConfiguration(configuration);

    // it was inside callback of RestService.getStudioAppConfig
    that.setState({
      ...that.state,
      configuration: configuration,
    });
  }

  handleToggle() {
    this.setState({
      ...this.state,
      drawerOpen: !this.state.drawerOpen,
    });
  }

  render() {
    const { studioAppConfig } = this.props;
    const role = studioAppConfig.currentToken.role;

    if (role === undefined) {
      return null;
    }

    let shouldUpdateChildren: boolean = false;
    if (this.props.location.pathname !== this.path) {
      this.path = this.props.location.pathname;
      this.updatePathPrefix(this.path);
      shouldUpdateChildren = true;
    }
    let pathPrefix = this.pathPrefix;

    let appTitle = 'Glance for Partners';
    let menuItems = [];
    let partnerIdToPartner: Map<string, Partner> = new Map<string, Partner>();
    let currentPartner;
    if (studioAppConfig.currentToken.partners) {
      studioAppConfig.currentToken.partners.forEach((partner) => {
        partnerIdToPartner.set(partner.partnerId, partner);
      });
    }
    if (this.props.params && this.props.params.partnerId) {
      appTitle = 'Glance for';
      currentPartner = partnerIdToPartner.get(this.props.params.partnerId);
    } else {
      currentPartner = partnerIdToPartner.values().next().value;
    }
    if (role != Role.PARTNER) {
      if (role == Role.ADMIN || role == Role.MODERATOR) {
        appTitle = 'Glance for Moderators';
        pathPrefix = '/moderator';
      } else if (role == Role.CURATOR) {
        appTitle = 'Glance for Curators';
        pathPrefix = '/curator';
      } else if (role == Role.DESIGNER) {
        appTitle = 'Glance for Designers';
        pathPrefix = '/designer';
      }
      menuItems.push(
        <MenuItem
          containerElement={<Link to={pathPrefix + '/drafts'} />}
          key="glance_drafts"
          onTouchTap={this.handleToggle}
          primaryText="Drafts"
          leftIcon={<FontIcon className="material-icons">drafts</FontIcon>}
        />,
      );
      menuItems.push(
        <MenuItem
          containerElement={<Link to={pathPrefix + '/analytics'} />}
          key="analytics"
          onTouchTap={this.handleToggle}
          primaryText="Analytics"
          leftIcon={<FontIcon className="material-icons">table_chart</FontIcon>}
        />,
      );

      menuItems.push(
        <MenuItem
          containerElement={<Link to={pathPrefix + '/segments'} />}
          key="segments"
          onTouchTap={this.handleToggle}
          primaryText="Segments"
          leftIcon={<FontIcon className="material-icons">pie_chart</FontIcon>}
        />,
        <MenuItem
          containerElement={<Link to={pathPrefix + '/segment-query'} />}
          key="segment-query"
          onTouchTap={this.handleToggle}
          primaryText="Segment Query"
          leftIcon={
            <FontIcon className="material-icons">query_builder</FontIcon>
          }
        />,
      );

      if (role == Role.ADMIN) {
        menuItems.push(
          <MenuItem
            containerElement={<Link to={pathPrefix + '/publishers'} />}
            key="Publishers"
            onTouchTap={this.handleToggle}
            primaryText="Publishers"
            leftIcon={<FontIcon className="material-icons">publish</FontIcon>}
          />,
        );
      }

      menuItems.push(
        <MenuItem
          containerElement={<Link to={pathPrefix + '/notification-settings'} />}
          key="notification_setting"
          onTouchTap={this.handleToggle}
          primaryText="Notification"
          leftIcon={
            <FontIcon className="material-icons">notifications</FontIcon>
          }
        />,
      );

      menuItems.push(
        <MenuItem
          containerElement={<Link to={pathPrefix + '/uploadFile'} />}
          key="upload_file"
          onTouchTap={this.handleToggle}
          primaryText="Upload File"
          leftIcon={
            <FontIcon className="material-icons">cloud_upload</FontIcon>
          }
        />,
      );

      menuItems.push(
        <MenuItem
          containerElement={<Link to={pathPrefix + '/uploadCsv'} />}
          key="upload_csv"
          onTouchTap={this.handleToggle}
          primaryText="Upload CSV"
          leftIcon={
            <FontIcon className="material-icons">cloud_upload</FontIcon>
          }
        />,
      );

      menuItems.push(
        <MenuItem
          containerElement={<Link to={pathPrefix + '/internalApproval'} />}
          key="internal_approval"
          onTouchTap={this.handleToggle}
          primaryText="Internal Approval"
          leftIcon={
            <FontIcon className="material-icons">done_outline</FontIcon>
          }
        />,
      );
    } else if (currentPartner) {
      pathPrefix = pathPrefix + '/' + currentPartner.partnerId;
    }

    menuItems.push(
      <MenuItem
        containerElement={<Link to={pathPrefix + '/published'} />}
        key="live_glances"
        onTouchTap={this.handleToggle}
        primaryText="Live Glances"
        leftIcon={<FontIcon className="material-icons">live_tv</FontIcon>}
      />,
    );

    // menuItems.push(
    //   <MenuItem
    //     containerElement={<Link to={pathPrefix + '/highlights'} />}
    //     key="highlights"
    //     onTouchTap={this.handleToggle}
    //     primaryText="HighLights"
    //     leftIcon={<FontIcon className="material-icons">highlight</FontIcon>}
    //   />,
    // );

    menuItems.push(<Divider key="divider" />);

    // const avatar = studioAppConfig.currentToken.user.pictureUrl ?
    //             <Avatar src={studioAppConfig.currentToken.user.pictureUrl}/> :
    //             <Avatar> {studioAppConfig.currentToken.user.name.substr(0,1)} </Avatar>
    menuItems.push(
      <MenuItem
        containerElement={<Link to={'/logout'} />}
        key="logout"
        onTouchTap={this.handleToggle}
        primaryText="Logout"
        leftIcon={<FontIcon className="material-icons">exit_to_app</FontIcon>}
        //rightAvatar={avatar}
      />,
    );
    if (!this.childrenWithProps || shouldUpdateChildren) {
      this.childrenWithProps = React.Children.map(
        this.props.children,
        (child: React.ReactElement<any>) => {
          return React.cloneElement(
            child,
            {
              region: region,
              conf: this.state.configuration,
              partnerMap: partnerIdToPartner,
            },
            null,
          );
        },
      );
    }
    return (
      <div>
        <AppBar
          title={
            studioAppConfig.currentToken ? (
              <CustomAppBar
                history={this.props.history}
                title={appTitle}
                user={studioAppConfig.currentToken}
                partner={currentPartner}
                partnerMap={partnerIdToPartner}
              />
            ) : null
          }
          style={{ position: 'fixed' }}
          onLeftIconButtonTouchTap={this.handleToggle}
        ></AppBar>

        <Drawer
          open={this.state.drawerOpen}
          docked={false}
          onRequestChange={(open) => {
            console.log(open);
            this.setState({ ...this.state, drawerOpen: open });
          }}
        >
          <div
            style={{ backgroundColor: Colors.cyan500 }}
            onClick={this.handleToggle}
          >
            <img
              src="../../../assets/images/logo_white.png"
              width="70px"
              style={{ margin: '0 auto', padding: '10px', display: 'block' }}
            />
          </div>
          <Menu style={{ width: 'auto' }}>{menuItems}</Menu>
        </Drawer>

        <div
          className=""
          style={{
            paddingTop: '60px',
            width: '90%',
            maxWidth: '1400px',
            margin: '0 auto',
            marginBottom: '5%',
          }}
        >
          {this.childrenWithProps}
        </div>
        <div className="" style={styles.footer}>
          Copyright © 2017 Glance. All Rights Reserved.
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    studioAppConfig: state.studioAppConfig,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatchFetchStudioAppConfig: () => dispatch(fetchStudioAppConfigAction()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App.tsx